import { Link } from "react-router-dom";

export default function PrivacyPolicyPage() {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-16 bg-slate-900">
        <div className="container-custom">
          <h1 className="heading-primary text-white mb-4" data-testid="privacy-title">
            Privacy Policy
          </h1>
          <p className="text-slate-400">Last updated: January 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="section-padding bg-white" data-testid="privacy-content">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto prose prose-slate prose-lg">
            <h2 className="heading-tertiary text-slate-900">1. Introduction</h2>
            <p className="text-slate-600 mb-8">
              BuyVistas ("we," "our," or "us") is committed to protecting your privacy. This Privacy 
              Policy explains how we collect, use, disclose, and safeguard your information when you 
              visit our website or use our services.
            </p>

            <h2 className="heading-tertiary text-slate-900">2. Information We Collect</h2>
            <p className="text-slate-600 mb-4">We may collect information about you in a variety of ways:</p>
            <h3 className="font-bold text-slate-800 mt-6 mb-2">Personal Data</h3>
            <p className="text-slate-600 mb-4">
              When you request a quote or contact us, we may collect personally identifiable information, 
              including but not limited to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Mailing address</li>
              <li>Property information</li>
            </ul>
            
            <h3 className="font-bold text-slate-800 mt-6 mb-2">Automatically Collected Information</h3>
            <p className="text-slate-600 mb-8">
              When you access our website, we may automatically collect certain information about your 
              device, including information about your web browser, IP address, time zone, and some of 
              the cookies that are installed on your device.
            </p>

            <h2 className="heading-tertiary text-slate-900">3. How We Use Your Information</h2>
            <p className="text-slate-600 mb-4">We use the information we collect to:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-8">
              <li>Provide, operate, and maintain our services</li>
              <li>Process your service requests and quotes</li>
              <li>Communicate with you about our services</li>
              <li>Send you marketing and promotional communications (with your consent)</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="heading-tertiary text-slate-900">4. Sharing Your Information</h2>
            <p className="text-slate-600 mb-8">
              We do not sell, trade, or otherwise transfer your personally identifiable information to 
              outside parties except as described in this policy. We may share information with trusted 
              third parties who assist us in operating our website, conducting our business, or servicing 
              you, so long as those parties agree to keep this information confidential.
            </p>

            <h2 className="heading-tertiary text-slate-900">5. Data Security</h2>
            <p className="text-slate-600 mb-8">
              We implement appropriate technical and organizational security measures designed to protect 
              the security of any personal information we process. However, please note that no method of 
              transmission over the Internet or electronic storage is 100% secure.
            </p>

            <h2 className="heading-tertiary text-slate-900">6. Your Rights</h2>
            <p className="text-slate-600 mb-4">Depending on your location, you may have the right to:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-8">
              <li>Access the personal information we hold about you</li>
              <li>Request correction of your personal data</li>
              <li>Request deletion of your personal data</li>
              <li>Opt-out of marketing communications</li>
              <li>Lodge a complaint with a supervisory authority</li>
            </ul>

            <h2 className="heading-tertiary text-slate-900">7. Third-Party Links</h2>
            <p className="text-slate-600 mb-8">
              Our website may contain links to third-party websites. We have no control over and assume 
              no responsibility for the content, privacy policies, or practices of any third-party sites 
              or services.
            </p>

            <h2 className="heading-tertiary text-slate-900">8. Children's Privacy</h2>
            <p className="text-slate-600 mb-8">
              Our services are not intended for individuals under the age of 18. We do not knowingly 
              collect personal information from children under 18.
            </p>

            <h2 className="heading-tertiary text-slate-900">9. Changes to This Policy</h2>
            <p className="text-slate-600 mb-8">
              We may update this Privacy Policy from time to time. We will notify you of any changes by 
              posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>

            <h2 className="heading-tertiary text-slate-900">10. Contact Us</h2>
            <p className="text-slate-600 mb-4">
              If you have questions about this Privacy Policy, please contact us:
            </p>
            <ul className="list-none text-slate-600 mb-8">
              <li><strong>Email:</strong> support@buyvistas.store</li>
              <li><strong>Phone:</strong> +1-888-435-4674</li>
              <li><strong>Address:</strong> 20 E 22nd St #4699, New York, NY 10165</li>
            </ul>

            <div className="mt-12 pt-8 border-t border-slate-200">
              <Link to="/" className="text-sky-600 hover:text-sky-700 font-semibold">
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
